import * as THREE from 'three';
import { scene } from './scene';
/* ============================================================
   有 rig 的敵人（現在只剩 Boss）的進出場
   ============================================================

   **2026-08-03 敵人大改版之後，這個檔只剩三個小工具。**

   原本它是雜魚的實例化渲染層（M8-d，draw call 1610 → 200），做法是
   「保留每隻的 Group 階層與既有動畫，只是不加進場景，每幀算完
   `matrixWorld` 再複製進 InstancedMesh」。那個做法存在的理由是
   **沿用一批已經正確的 Object3D 動畫程式碼**。

   新的小怪沒有 Object3D 可言 —— 它們是「part 表 + `fn(P, o)`」，
   矩陣直接算得出來（規格 §6.1 的 `pivotTop` 就是為了補「沒有階層」
   這件事）。所以那一整套模板／複製流程沒有消費者了，整段刪掉，
   由 `render/enemy-field.ts` 取代。要撈舊實作去 git 歷史。

   留下來的三件事都只服務 Boss：它仍然是真 rig、仍然加進場景、
   仍然要 `collectMeshes` 快取子 mesh 清單給受擊閃白用。 */

/** 收集一個 rig 底下所有的 mesh。DFS 前序，同型別的敵人順序一定相同。 */
export function collectMeshes(root): THREE.Mesh[] {
  var out: THREE.Mesh[] = [];
  root.traverse(function (o) { if ((o as any).isMesh) out.push(o as THREE.Mesh); });
  return out;
}

/** 這隻要不要用真正的 rig。

    **小怪一律不要，即使升格成精英也不要** —— 新的精英走
    `enemy-field.ts` 的「另一個型別」路徑（同一張 part 表 + `ex[]` 額外部件），
    四隻精英共用 10 個 draw call，比規格原訂的「每隻真 mesh 8–12」還省。 */
export function usesRig(e) { return !e.T.fam && !!(e.elite || e.T.boss); }

/** 敵人進場。小怪不進場景（由實例化代勞），Boss 照舊加進去。 */
export function attachEnemy(e) {
  if (usesRig(e)) { if (!e.root.parent) scene.add(e.root); }
  else if (e.root.parent) scene.remove(e.root);
}

/** 敵人退場。小怪本來就不在場景裡，這裡只處理有 rig 的。 */
export function detachEnemy(e) {
  if (e.root.parent) scene.remove(e.root);
}
